/* eslint-disable no-undef */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global document, Office */
import "./taskpane.css";
import { initializeIcons } from "@fluentui/react";
import * as ReactDOM from "react-dom";
import * as React from "react";
import { AppContainer } from "react-hot-loader";
import App from "./components/App";

let isOfficeInitialized = false;
initializeIcons();
const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <Component title={""} isOfficeInitialized={isOfficeInitialized} />
    </AppContainer>,
    document.getElementById("container")
  );
};
Office.onReady((info) => {
  if (info.host === Office.HostType.Word) {
    run();
  }
});

export async function run() {
  isOfficeInitialized = true;
  render(App);
}

render(App);
